// Хелпер для реструктуризации ответов от API
import _ from 'lodash';

export default (responseJson, data, restructureFunction) => {
  if (!responseJson.success) {
    return {
      response: responseJson,
      restructureData: null
    };
  }
  if (_.isArray(data)) {
    return {
      response: responseJson,
      restructureData: _.map(data, item => restructureFunction(item))
    };
  }
  return {
    response: responseJson,
    restructureData: restructureFunction(data)
  };
};



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/restructureResponse.js